/* auth module */
export const SET_USER = 'SET_USER';
export const SET_REMEMBER_USER = 'SET_REMEBER_USER';
export const UNSET_USER = 'UNSET_USER';
export const SET_URL = 'SET_URL';

/* loading module */
export const SET_LOADING = 'SET_LOADING';
export const UNSET_LOADING = 'UNSET_LOADING';

/* advisers module */
export const SET_ADVISERS_LIST = 'SET_ADVISERS_LIST';

/* banks module */
export const SET_BANKS_ACCOUNTS = 'SET_BANKS_ACCOUNTS';

/* addresses module */
export const SET_LOCATION_COMMUNITIES = 'SET_LOCATION_COMMUNITIES';
export const SET_LOCATION_PROVINCES = 'SET_LOCATION_PROVINCES';
export const SET_LOCATION_TOWNS = 'SET_LOCATION_TOWNS';
export const SET_LOCATION_POSTAL_CODES = 'SET_LOCATION_POSTAL_CODES';

/* headquarters module */
export const SET_HEADQUARTERS_LIST = 'SET_HEADQUARTERS_LIST';

/* fee types module */
export const SET_AGREEMENTS_LIST = 'SET_AGREEMENTS_LIST';

/* fee types module */
export const SET_FEE_TYPES_LIST = 'SET_FEE_TYPES_LIST';

/* fee types module */
export const SET_CNAE_LIST = 'SET_CNAE_LIST';

/* unsubscribe reasons module*/
export const SET_UNSUBSCRIBE_REASONS_LIST = 'SET_UNSUBSCRIBE_REASONS_LIST';

/* global filter */
export const SET_FILTERS_LIST = 'SET_FILTERS_LIST';
export const SET_USER_TEXT_FILTER = 'SET_USER_TEXT_FILTER';
export const SET_ROLES_TEXT_FILTER = 'SET_ROLES_TEXT_FILTER';

export const SET_LIST_CONTACT_RESPONSE = 'SET_LIST_CONTACT_RESPONSE';
export const CLEAR_LIST_CONTACT_RESPONSE = 'CLEAR_LIST_CONTACT_RESPONSE';
export const SET_CONTACTS = 'SET_CONTACTS';
export const CLEAR_CONTACT = 'CLEAR_CONTACT';
export const SET_SEARCH_MEMBER_RESPONSE = 'SET_SEARCH_MEMBER_RESPONSE';
export const CLEAR_SEARCH_MEMBER_RESPONSE = 'CLEAR_SEARCH_MEMBER_RESPONSE';
